export * from "./controller";
export * from "./component";

export const HtmlTemplate: string =
  require("!html-loader!./index.html").default;
